import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ProductAuth14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_177)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.25 7C0.25 3.27208 3.27208 0.25 7 0.25C10.7279 0.25 13.75 3.27208 13.75 7C13.75 10.7279 10.7279 13.75 7 13.75C3.27208 13.75 0.25 10.7279 0.25 7ZM7 1.75C4.35515 1.75 2.16709 3.70578 1.80317 6.25H7.1894L5.46973 4.53033L6.53039 3.46967L10.0607 7L6.53039 10.5303L5.46973 9.46967L7.18939 7.75H1.80317C2.16709 10.2942 4.35515 12.25 7 12.25C9.8995 12.25 12.25 9.8995 12.25 7C12.25 4.1005 9.8995 1.75 7 1.75Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_177'>
        <rect width='14' height='14' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

ProductAuth14.displayName = 'ProductAuth14';
export default ProductAuth14;
